import { FileType2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import TemplateManager from "@/components/TemplateManager";
import SuggestedTemplates from "@/components/SuggestedTemplates";

/**
 * Message templates — the library automated messaging draws from.
 *
 * The catalog comes first — it is what someone opening this page is usually
 * here for. AI suggestions sit below as a secondary prompt: worth seeing, but
 * not the reason you navigated here.
 *
 * Both write paths are super-admin only server-side. This page renders an
 * explicit explanation for other admins rather than an empty screen, so the
 * absence reads as a permission boundary rather than a broken page.
 */
export default function Templates() {
  const { isSuperAdmin } = useAuth();

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center gap-3 mb-2">
        <div className="h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center">
          <FileType2 className="h-5 w-5 text-purple-600" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">
            Message Templates
          </h1>
          <p className="text-sm text-gray-500">
            WhatsApp requires pre-approved templates to message someone who
            hasn't replied in the last 24 hours. This is that library.
          </p>
        </div>
      </div>

      {!isSuperAdmin ? (
        <div className="mt-8 rounded-lg border border-amber-200 bg-amber-50 p-6 flex items-start gap-3">
          <ShieldAlert className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <div>
            <h2 className="text-sm font-semibold text-amber-900">
              Super admin access required
            </h2>
            <p className="text-sm text-amber-800 mt-1">
              Creating a template submits it to WhatsApp for review, and
              deleting one can't be undone. Ask a super admin if you need a
              change here.
            </p>
          </div>
        </div>
      ) : (
        <>
          <TemplateManager />
          <SuggestedTemplates />
        </>
      )}
    </div>
  );
}
